import { Alert } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledAlert = styled(Alert)(() => ({
  maxHeight: '90vh',
  overflowY: 'auto',
  scrollbarWidth: 'none',
  WebkitOverflowScrolling: 'touch',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
    width: 0,
    height: 0
  },
  '& .MuiAlert-message': {
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
      width: 0,
      height: 0
    }
  }
}));
